"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.function.name");

var _objectWithoutProperties = require("/root/icatu-frontend/node_modules/@babel/runtime/helpers/objectWithoutProperties");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputSelectComponent = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _utils = require("@creditas/utils");

var _components = require("./components");

var _core = require("@emotion/core");

var propTypes = process.env.NODE_ENV !== "production" ? {
  component: (0, _propTypes.oneOfType)([_propTypes.elementType, _propTypes.string]),
  className: _propTypes.string,
  'data-testid': _propTypes.string,
  withRef: (0, _propTypes.oneOfType)([_propTypes.object, _propTypes.func]),
  onBlur: _propTypes.func,
  onChange: _propTypes.func,
  onFocus: _propTypes.func,
  onInput: _propTypes.func,
  value: _propTypes.string,
  defaultValue: _propTypes.string,
  type: _propTypes.string,
  name: _propTypes.string,
  id: _propTypes.string,
  readOnly: _propTypes.bool,
  size: _propTypes.string,
  disabled: _propTypes.bool,
  inputFocus: _propTypes.bool,
  inputHover: _propTypes.bool,
  width: _propTypes.string,
  variant: _propTypes.string,
  hideDefaultOption: _propTypes.bool,
  options: (0, _propTypes.oneOfType)([(0, _propTypes.arrayOf)(_propTypes.string), (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    value: _propTypes.string.isRequired,
    text: _propTypes.string.isRequired
  }).isRequired)]).isRequired
} : {};
var defaultProps = {
  component: 'select'
};

var InputSelectComponent = function InputSelectComponent(_ref) {
  var withRef = _ref.withRef,
      component = _ref.component,
      className = _ref.className,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'select' : _ref$type,
      dataTestId = _ref['data-testid'],
      name = _ref.name,
      id = _ref.id,
      readOnly = _ref.readOnly,
      size = _ref.size,
      disabled = _ref.disabled,
      inputFocus = _ref.inputFocus,
      inputHover = _ref.inputHover,
      width = _ref.width,
      variant = _ref.variant,
      hideDefaultOption = _ref.hideDefaultOption,
      options = _ref.options,
      value = _ref.value,
      defaultValue = _ref.defaultValue,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      onInput = _ref.onInput,
      other = _objectWithoutProperties(_ref, ["withRef", "component", "className", "type", "data-testid", "name", "id", "readOnly", "size", "disabled", "inputFocus", "inputHover", "width", "variant", "hideDefaultOption", "options", "value", "defaultValue", "onBlur", "onChange", "onFocus", "onInput"]);

  return (0, _core.jsx)(_components.InputSelectComponent, (0, _extends2["default"])({
    as: component,
    ref: withRef,
    className: className,
    "data-testid": dataTestId,
    name: name,
    id: id,
    type: type,
    readOnly: readOnly,
    size: size,
    disabled: disabled,
    inputFocus: inputFocus,
    inputHover: inputHover,
    variant: variant,
    width: width,
    options: options,
    defaultValue: defaultValue,
    value: value,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    onInput: onInput
  }, other), !hideDefaultOption && (0, _core.jsx)(_components.OptionComponent, null), options && options.map(function (option) {
    if (typeof option === 'string') {
      return (0, _core.jsx)(_components.OptionComponent, {
        key: option
      }, option);
    }

    return (0, _core.jsx)(_components.OptionComponent, {
      key: option.value,
      value: option.value
    }, option.text);
  }));
};

process.env.NODE_ENV !== "production" ? InputSelectComponent.propTypes = propTypes : void 0;
InputSelectComponent.defaultProps = defaultProps;
var WithForwardRef = (0, _utils.withForwardRef)(InputSelectComponent);
exports.InputSelectComponent = WithForwardRef;